import React from "react";
import { Reveal } from "../Reveal";
import { ArrowUpRight } from "lucide-react";
import { trackEvent } from "../../lib/analytics";

export const Services = ({ data }) => {
  const services = data?.services || [];

  return (
    <section id="services" className="relative bg-[#0a0a0a] py-16 md:py-24" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Reveal className="mb-6 flex items-center gap-4">
              <span className="h-px w-12 bg-gold" />
              <span className="text-gold text-xs uppercase tracking-[0.3em]">What We Do</span>
            </Reveal>
            <Reveal>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight">
                Our <span className="italic text-gold">Services</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-smoke max-w-sm md:text-right">
              A complete suite of premium hospitality experiences, tailored to your vision.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.12}>
              <a
                href="#contact"
                data-scroll-to="contact"
                data-testid={`service-card-${s.id}`}
                onClick={() => trackEvent("service_click", { service_id: s.id, service_title: s.title })}
                className="group flex h-full flex-col overflow-hidden rounded-xl border border-line bg-surface transition-all duration-500 hover:border-gold/50 hover:-translate-y-1"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="h-full w-full object-cover brightness-75 transition-all duration-700 group-hover:brightness-110 group-hover:scale-110"
                  />
                  <div className="absolute top-4 left-4 flex h-10 w-10 items-center justify-center rounded-full bg-void/70 backdrop-blur-md font-display text-gold">
                    0{i + 1}
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <h3 className="font-display text-2xl text-ink mb-3 flex items-center justify-between">
                    {s.title}
                    <ArrowUpRight
                      size={22}
                      className="text-smoke transition-all duration-300 group-hover:text-gold group-hover:rotate-45"
                    />
                  </h3>
                  <p className="text-smoke text-sm leading-relaxed">{s.description}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
